'use strict';
import {EwSiteApp} from '../../app/ewsiteapp';

EwSiteApp.controller('aeivedlysCtrl', ['$scope', '$http', function ($scope, $http, ) {
	$scope.combinations = aeivedlysData.combinations;
	$scope.dataUrl = aeivedlysData.dataUrl;
	$scope.objectSearched = false;
	$scope.lng = '';
	$scope.igg = '';
	$scope.lgg = '';
	$scope.link = '';
	$scope.text_col = '';
	$scope.links = [];
	$scope.objekto_numeris = aeivedlysData.objectNo;
	$scope.item = {
		LOG: '',
		IGG: '',
		LGG: ''
	};
	$scope.displayStatus = 0;

	$scope.choiseChanged = function () {
		if ($scope.lng && $scope.igg && $scope.lgg) {
			$scope.link = $scope.combinations['' + $scope.lng + '' + $scope.igg + '' + $scope.lgg];
		}
	};

	$scope.setDisplayStatus = function (status) {
		$scope.displayStatus = status;
	};

	$scope.resetRadioValues = function () {
		$scope.lng = null;
		$scope.igg = null;
		$scope.lgg = null;
	};

	$scope.gotoLink = function () {
		if ($scope.lng === '0' && $scope.igg === '0' && $scope.lgg === '0') {
			$scope.setDisplayStatus(1);
			return;
		}
		if ($scope.lng === '1' && $scope.igg === '1' && $scope.lgg === '0') {
			$scope.links = $scope.combinations['' + $scope.lng + '' + $scope.igg + '' + $scope.lgg];
			$scope.setDisplayStatus(2);
			return;
		}
		location.href = $scope.link;

		$scope.resetRadioValues();
	};

	$scope.getIconPath = function (item) {
		return theme_path + item.icon;
	};

	$scope.searchObjectNr = function () {
		$scope.objectSearched = false;
		$scope.text_col = '';
		$scope.checking_nr = true;
		$scope.error_message = '';
		$scope.item = {
			LOG: '',
			IGG: '',
			LGG: ''
		};
		if ($scope.dataUrl !== '' && $scope.objekto_numeris !== '') {
			$http({
				method: 'POST',
				url: $scope.dataUrl,
				data: {
					nr: $scope.objekto_numeris
				},
				xsrfCookieName: secure_xsrf_name,
				xsrfHeaderName: 'X-' + secure_xsrf_name
			}).then(function (response) {
				if (response.data.success) {
					for (let list of response.data.data) {
						$scope.objectSearched = true;
						if (list.text_col !== '' && $scope.text_col === '') {
							$scope.text_col = list.text_col;
						}
						if (typeof (list.tipas) !== 'undefined') {
							if (list.tipas === 'LOG') {
								$scope.item.LOG = list.galia;
							}
							if (list.tipas === 'IGG') {
								$scope.item.IGG = list.galia;
							}
							if (list.tipas === 'LGG') {
								$scope.item.LGG = list.galia;
							}
						}
					}
				} else {
					$scope.error_message = response.data.message;
				}
			}, function (response) {
				console.log(['Error', response]);
			}).then(function () {
				$scope.checking_nr = false;
			});
		}
	};

	if($scope.objekto_numeris != ''){
		$scope.searchObjectNr();
	}
}]);